import DocPdf from "src/components/S3/DocPdf";
import { ReactComponent as NoFile } from "src/assets/svg/no-file.svg";

import { Talent } from "src/types";

const Resume = ({ t }: { t: Talent }) => {
  if (!t.resume || !t.resume_presigned)
    return (
      <div className="mx-auto flex flex-col items-center gap-6 pt-[120px]">
        <NoFile className="w-[220px] h-[220px]" />
        <p className="font-poppins text-xl font-semibold">No Resume Found</p>
      </div>
    );
  return <DocPdf resume={t.resume_presigned} />;
};

export default Resume;
